import React from "react";
import { IconButton, Tooltip, createStyles, WithStyles, withStyles } from "@material-ui/core";
import { Favorite, FavoriteBorder } from "@material-ui/icons";
import { isPlayerFavourite } from "../../utils/playerFavourites";

interface Props extends WithStyles<typeof styles> {
  playerId: string;
  currentUserId?: string;
  favPlayerIds?: string[];
  onToggle: (playerId: string, favourited: boolean) => void;
  className?: string;
}

const PlayerFavouriteToggleBase = ({
  playerId,
  currentUserId,
  favPlayerIds,
  onToggle,
  className,
  classes,
}: Props) => {
  if (!currentUserId || playerId === currentUserId) return null;

  const favourited = isPlayerFavourite(playerId, favPlayerIds);

  return (
    <Tooltip title={favourited ? "Remove from favourites" : "Add to favourites"}>
      <IconButton
        size="small"
        className={`${classes.root}${className ? ` ${className}` : ""}`}
        aria-label={favourited ? "Remove from favourites" : "Add to favourites"}
        onClick={event => {
          event.stopPropagation();
          event.preventDefault();
          onToggle(playerId, favourited);
        }}
      >
        {favourited ? (
          <Favorite className={classes.icon} color="secondary" />
        ) : (
          <FavoriteBorder className={classes.icon} />
        )}
      </IconButton>
    </Tooltip>
  );
};

const styles = () =>
  createStyles({
    root: {
      padding: 2,
      width: 22,
      height: 22,
      flexShrink: 0,
    },
    icon: {
      fontSize: 15,
    },
  });

export const PlayerFavouriteToggle = withStyles(styles)(PlayerFavouriteToggleBase);
